<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="modal_type02">
          <div class="modal-head">
            <h1>{{ $t('modal.permission.title') }}</h1>
          </div>
          <div class="modal-con">
            <div class="modal-txt gray14">
              <p>{{ $t('modal.permission.description') }}</p>
            </div>

            <div class="modal-access">
              <div class="choice-access">
                <h2>{{ $t('modal.permission.optional') }}</h2>
                <ul class="access-box mt6">
                  <li>
                    <div class="access-icon">
                      <i class="i-location-modal"></i>
                      <p class="access-tit">
                        {{ $t('modal.permission.location') }}
                      </p>
                    </div>
                    <p class="access-txt">
                      {{ $t('modal.permission.location_desc') }}
                    </p>
                  </li>
                  <li class="mt16">
                    <div class="access-icon">
                      <i class="i-camera-modal"></i>
                      <p class="access-tit">
                        {{ $t('modal.permission.camera') }}
                      </p>
                    </div>
                    <p class="access-txt">
                      {{ $t('modal.permission.camera_desc') }}
                    </p>
                  </li>
                  <li class="mt16">
                    <div class="access-icon">
                      <i class="i-photo-modal"></i>
                      <p class="access-tit">
                        {{ $t('modal.permission.photo') }}
                      </p>
                    </div>
                    <p class="access-txt">
                      {{ $t('modal.permission.photo_desc') }}
                    </p>
                  </li>
                  <li class="mt16">
                    <div class="access-icon">
                      <i class="i-call-modal"></i>
                      <p class="access-tit">
                        {{ $t('modal.permission.phone') }}
                      </p>
                    </div>
                    <p class="access-txt">
                      {{ $t('modal.permission.phone_desc') }}
                    </p>
                  </li>
                  <li class="mt16">
                    <div class="access-icon">
                      <i class="i-alarm-modal"></i>
                      <p class="access-tit">
                        {{ $t('modal.permission.notification') }}
                      </p>
                    </div>
                    <p class="access-txt">
                      {{ $t('modal.permission.notification_desc') }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn yd-cta yd-cta--primary" @click="dismiss">
                {{ $t('modal.permission.confirm') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DeviceManager from '@/common/utils/DeviceManager';
import { close } from '@/common/utils/ControlModal';
import Util from '@/common/utils/Util';
const { androidPermission } = Util;
const dismiss = () => {
  androidPermission();
  close(DeviceManager.actions.FIRST_RUN);
  DeviceManager.reduce(DeviceManager.actions.UPDATE);
};
</script>

<style scoped></style>
/* *Created on 2023-11-01 *ProjectName user */
